import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import { sendSalonInfoUpdateEmail, getContent } from '@/services/api';
import Placeholder from '../../components/Placeholder';
import {
  Section,
  SectionLabel,
  InnerInput,
  InnerConfirm,
  InnerThanks,
  InnerError,
  Form,
  Dl,
  Dt,
  Dd,
  Required,
  Error,
  Input,
  Label,
  CheckboxIcon,
  Checkbox,
  SelectWrap,
  Select,
  Option,
  ButtonContainer,
  Button,
  ButtonLink,
  Hr,
  Title,
  Description,
  LineTitle,
  LineItem,
  LineItems,
} from './SalonInfoUpdatePage.style';
import { TABLET_P } from "../../constants";
import BreadCrumbMenu from "../../components/BreadCrumbMenus";

class SalonInfoUpdatePage extends Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.confirmRef = React.createRef();
    this.thanksRef = React.createRef();
  }

  state = {
    page: 'input',
    corporateIdErrorExist: false,
    phoneNumberErrorExist: false,
    salonNameErrorExist: false,
    //
    corporateId: '',
    salonCode: '',
    phoneNumber: '',
    salonName: '',
    email: '',
    zipCode: '',
    address: '',
    tel: '',
    website: '',
    nearbyStations: '',
    parking: '',
    productsAdd: {},
    productsDel: {},
    // SEO 対策に必要なメタデータ
    siteOptionsMetaData: {},
  };

  componentWillMount() {
    const { locale } = this.props;

    if (locale) {
      // SEO 対策に必要なメタデータを取得する
      getContent({ contentType: 'siteOptionsMetaData', locale, slug: 'salon-info-update' }).then(siteOptionsMetaData =>
        this.setState({ siteOptionsMetaData })
      );
    }
  }

  componentDidMount() {
    // console.log('[form]', this.inputRef.current.classList);
    // this.inputRef.current.style.opacity = '1.0';
    // this.formRef.classList.addClass('test');
    // console.log('[sendSalonInfoUpdateEmail]', sendSalonInfoUpdateEmail);
  }

  info = {
    corporateId: '',
    salonCode: '',
    phoneNumber: '',
    salonName: '',
    email: '',
    zipCode: '',
    address: '',
    tel: '',
    website: '',
    nearbyStations: '',
    parking: '',
    productsAdd: {},
    productsDel: {},
  };

  clickHandleConfirm = () => {
    // エラーチェック
    const bool1 = this.validCorporateId();
    const bool2 = this.validPhoneNumber();
    const bool3 = this.validSalonName();
    if (!bool1 || !bool2 || !bool3) {
      window.scrollTo(0, 0);
      return false;
    }

    // 入力値保存
    this.info = {
      corporateId: this.val('corporateId') || null,
      salonCode: this.val('salonCode') || null,
      phoneNumber: this.val('phoneNumber') || null,
      salonName: this.val('salonName') || null,
      email: this.val('email') || null,
      emailFrom: this.props.copy.emailFrom || null,
      emailTo: this.props.copy.emailTo || null,
      salonInfo: {
        zipCode: this.val('zipCode') || null,
        address: this.val('address') || null,
        tel: this.val('tel') || null,
        website: this.val('website') || null,
        nearbyStations: this.val('nearbyStations') || null,
        parking: this.val('parking') || null,
        productsAdd: this.objectToArray(this.val('productsAdd')) || null,
        productsDel: this.objectToArray(this.val('productsDel')) || null,
      },
    };

    this.setState(() => ({
      corporateId: this.val('corporateId'),
      salonCode: this.val('salonCode'),
      phoneNumber: this.val('phoneNumber'),
      salonName: this.val('salonName'),
      email: this.val('email'),
      zipCode: this.val('zipCode'),
      address: this.val('address'),
      tel: this.val('tel'),
      website: this.val('website'),
      nearbyStations: this.val('nearbyStations'),
      parking: this.val('parking'),
      productsAdd: this.val('productsAdd'),
      productsDel: this.val('productsDel'),
    }));

    // 確認画面へ
    this.setState(() => ({ page: 'confirm' }));

    window.scrollTo(0, 0);
    return true;
  };

  clickHandleBack = () => {
    this.setState(() => ({ page: 'input' }));
    window.scrollTo(0, 0);
  };

  clickHandleSubmit = () => {
    window.scrollTo(0, 0);
    sendSalonInfoUpdateEmail(this.info)
      .then(() => {
        this.setState(() => ({ page: 'thanks' }));
        // history.push(`/${locale}/stylist/profile`);
      })
      .catch(() => {
        // this.setState({
        //   errorOnSend: true,
        //   loading: false,
        // });
        this.setState(() => ({ page: 'error' }));
      });
  };

  val = name => {
    const selector = `[name^="${name}"]`;
    const elem = document.requestForm.querySelector(selector);

    if (elem.tagName === 'INPUT' && elem.type === 'text') {
      return elem.value;
    } else if (elem.tagName === 'INPUT' && elem.type === 'checkbox') {
      const elems = document.requestForm.querySelectorAll(selector);
      const obj = {};
      for (let i = 0; i < elems.length; i += 1) {
        if (elems[i].checked) {
          const lineFieldId = elems[i].name.match(/^[a-zA-Z]+\[(.+)\]$/)[1];
          if (!obj[lineFieldId]) {
            obj[lineFieldId] = [];
          }
          obj[lineFieldId].push(elems[i].value);
        }
      }
      return obj;
    } else if (elem.tagName === 'SELECT') {
      return elem.options[elem.selectedIndex].value;
    }

    return '';
  };

  objectToArray = obj => {
    const arr = [];
    for(let k in obj) {
      arr.push({
        lineCategory: k,
        lines: obj[k],
      });
    }
    console.log(arr);
    return arr;
  };

  handleChange = e => {
    // const { setResult } = this.props;
    // const text = e.target.value;
    // if (text.length >= 3) {
    //   this.search(text);
    // } else {
    //   setResult(undefined);
    // }
    // this.setState({ text });
    // console.log(text);
  };

  handleKeyUp = e => {
    // const { text } = this.state;
    // if (e.keyCode === 13 && text.length > 0) {
    //   this.search(text);
    // }
  };

  handleBlur = e => {
    switch (e.target.name) {
      case 'corporateId':
        this.validCorporateId(e);
        break;
      case 'phoneNumber':
        this.validPhoneNumber(e);
        break;
      case 'salonName':
        this.validSalonName(e);
        break;
      default:
    }
  };

  validCorporateId = e => {
    const val = e != null ? e.target.value : document.requestForm.querySelector('input[name="corporateId"]').value;
    const bool = !val.match(/^([0-9]{4,5}|[a-zA-Z][0-9]{4})$/);
    this.setState(() => ({ corporateIdErrorExist: bool }));
    return !bool;
  };

  validPhoneNumber = e => {
    const val = e != null ? e.target.value : document.requestForm.querySelector('input[name="phoneNumber"]').value;
    const bool = !val.match(/^(?:\+?\d+-)?\d+(?:-\d+){2}$|^\+?\d+$/);
    this.setState(() => ({ phoneNumberErrorExist: bool }));
    return !bool;
  };

  validSalonName = e => {
    const val = e != null ? e.target.value : document.requestForm.querySelector('input[name="salonName"]').value;
    const bool = !val;
    this.setState(() => ({ salonNameErrorExist: bool }));
    return !bool;
  };

  nl2br = str => {
    const result = str.split('\n').join('<br />');
    return result;
  };

  render() {
    const { locale } = this.props;
    const {
      title,
      description,
      corporateId,
      corporateIdPh,
      salonCode,
      salonCodePh,
      phoneNumber,
      phoneNumberPh,
      salonName,
      salonNamePh,
      email,
      emailPh,
      corporateIdError,
      phoneNumberError,
      salonNameError,
      changeTitle,
      zipCode,
      zipCodePh,
      address,
      addressPh,
      tel,
      telPh,
      website,
      websitePh,
      nearbyStations,
      nearbyStationsPh,
      parking,
      parkingItems,
      productsAdd,
      productsDel,
      confirmButton,
      confirmTitle,
      confirmDescription,
      backButton,
      submitButton,
      thanksTitle,
      thanksDescription,
      errorTitle,
      errorDescription,
      completeButtom,
      lines,
    } = this.props.copy;
    const { page, corporateIdErrorExist, phoneNumberErrorExist, salonNameErrorExist, siteOptionsMetaData } = this.state;
    return (
      <React.Fragment>
        {_.get(siteOptionsMetaData, 'metaData') && (
          <Helmet
            title={_.get(siteOptionsMetaData.metaData, 'title')}
            link={[
              makeCanonicalTagObj(locale, '/salon-info-update'),
              ...makeHreflangTagArr(siteOptionsMetaData.metaData.region, '/salon-info-update'),
            ]}
            meta={[
              {
                name: 'description',
                content: _.get(siteOptionsMetaData.metaData, 'description'),
              },
              {
                name: 'keyword',
                content: _.get(siteOptionsMetaData.metaData, 'keyword'),
              },
              // TODO: OGP タグは一旦保留 (2020年01月07日)
              // {
              //   property: 'og:url',
              //   content: _.get(siteOptionsMetaData.metaData, 'url'),
              // },
              // {
              //   property: 'og:type',
              //   content: _.get(siteOptionsMetaData.metaData, 'type'),
              // },
              // {
              //   property: 'og:title',
              //   content: _.get(siteOptionsMetaData.metaData, 'title'),
              // },
              // {
              //   property: 'og:image',
              //   content: _.get(siteOptionsMetaData.metaData, 'image.file.url'),
              // },
              // {
              //   property: 'og:description',
              //   content: _.get(siteOptionsMetaData.metaData, 'description'),
              // },
              // {
              //   property: 'og:site_name',
              //   content: _.get(siteOptionsMetaData.metaData, 'siteName'),
              // },
            ]}
          />
        )}
        <Section>
          {(() => {
            // console.log('[copy]', this.props.copy);
          })()}
          {/* --------------------------------------------------
            * input
            * -------------------------------------------------- */}
          <InnerInput page={page}>
            <Title>{title || <Placeholder w="200px" h="30px" />}</Title>
            {description && description !== '' ? (
              <Description dangerouslySetInnerHTML={{ __html: this.nl2br(description) }} />
            ) : null}
            <Form name="requestForm">
              <Dl>
                <Dt>
                  {corporateId || <Placeholder w="200px" h="30px" />}
                  <Required>*</Required>
                </Dt>
                <Dd>
                  <Input
                    type="text"
                    name="corporateId"
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                    onBlur={this.handleBlur}
                    placeholder={corporateIdPh || ''}
                  />
                  <Error error={corporateIdErrorExist}>{corporateIdError || 'error'}</Error>
                </Dd>
                <Dt>{salonCode || <Placeholder w="200px" h="30px" />}</Dt>
                <Dd>
                  <Input
                    type="text"
                    name="salonCode"
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                    placeholder={salonCodePh || ''}
                  />
                </Dd>
                <Dt>
                  {phoneNumber || <Placeholder w="200px" h="30px" />}
                  <Required>*</Required>
                </Dt>
                <Dd>
                  <Input
                    type="text"
                    name="phoneNumber"
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                    onBlur={this.handleBlur}
                    placeholder={phoneNumberPh || ''}
                  />
                  <Error error={phoneNumberErrorExist}>{phoneNumberError || 'error'}</Error>
                </Dd>
                <Dt>
                  {salonName || <Placeholder w="200px" h="30px" />}
                  <Required>*</Required>
                </Dt>
                <Dd>
                  <Input
                    type="text"
                    name="salonName"
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                    onBlur={this.handleBlur}
                    placeholder={salonNamePh || ''}
                  />
                  <Error error={salonNameErrorExist}>{salonNameError || 'error'}</Error>
                </Dd>
                <Dt>{email || <Placeholder w="200px" h="30px" />}</Dt>
                <Dd>
                  <Input
                    type="text"
                    name="email"
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                    placeholder={emailPh || ''}
                  />
                </Dd>
              </Dl>
              <SectionLabel>{changeTitle || <Placeholder w="200px" h="30px" />}</SectionLabel>
              <Dl>
                <Dt>{zipCode || <Placeholder w="200px" h="30px" />}</Dt>
                <Dd>
                  <Input
                    type="text"
                    name="zipCode"
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                    placeholder={zipCodePh || ''}
                  />
                </Dd>
                <Dt>{address || <Placeholder w="200px" h="30px" />}</Dt>
                <Dd>
                  <Input
                    type="text"
                    name="address"
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                    placeholder={addressPh || ''}
                  />
                </Dd>
                <Dt>{tel || <Placeholder w="200px" h="30px" />}</Dt>
                <Dd>
                  <Input
                    type="text"
                    name="tel"
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                    placeholder={telPh || ''}
                  />
                </Dd>
                <Dt>{website || <Placeholder w="200px" h="30px" />}</Dt>
                <Dd>
                  <Input
                    type="text"
                    name="website"
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                    placeholder={websitePh || ''}
                  />
                </Dd>
                <Dt>{nearbyStations || <Placeholder w="200px" h="30px" />}</Dt>
                <Dd>
                  <Input
                    type="text"
                    name="nearbyStations"
                    onChange={this.handleChange}
                    onKeyUp={this.handleKeyUp}
                    placeholder={nearbyStationsPh || ''}
                  />
                </Dd>
                <Dt>{parking || <Placeholder w="200px" h="30px" />}</Dt>
                <Dd>
                  <SelectWrap>
                    <Select name="parking">
                      <Option value="" />
                      {(() => {
                        const items = [];
                        if (parkingItems && Array.isArray(parkingItems)) {
                          for (let i = 0; i < parkingItems.length; i += 1) {
                            items.push(
                              <Option value={parkingItems[i]} key={i}>
                                {parkingItems[i]}
                              </Option>
                            );
                          }
                        }
                        return items;
                      })()}
                    </Select>
                  </SelectWrap>
                </Dd>
              </Dl>
              <Dl>
                <Dt>{productsAdd || <Placeholder w="200px" h="30px" />}</Dt>
                <Dd>
                  {(() => {
                    const items = [];
                    if (lines && Array.isArray(lines)) {
                      for (let i = 0; i < lines.length; i += 1) {
                        const obj = lines[i];
                        if (
                          obj &&
                          typeof obj === 'object' &&
                          'lineFieldId' in obj &&
                          'lines' in obj &&
                          Array.isArray(obj.lines)
                        ) {
                          items.push(<LineTitle key={i}>{obj.lineFieldId}</LineTitle>);
                          for (let j = 0; j < obj.lines.length; j += 1) {
                            items.push(
                              <LineItem key={`${i}-${j}`}>
                                <Label>
                                  <Checkbox
                                    type="checkbox"
                                    name={`productsAdd[${obj.lineFieldId}]`}
                                    value={obj.lines[j]}
                                    onChange={this.handleChange}
                                  />
                                  <CheckboxIcon />
                                  {obj.lines[j] || <Placeholder w="100px" h="30px" />}
                                </Label>
                              </LineItem>
                            );
                          }
                        }
                      }
                    }
                    return items;
                  })()}
                </Dd>
                {/* <Hr /> */}
                <Dt>{productsDel || <Placeholder w="200px" h="30px" />}</Dt>
                <Dd>
                  {(() => {
                    const items = [];
                    if (lines && Array.isArray(lines)) {
                      for (let i = 0; i < lines.length; i += 1) {
                        const obj = lines[i];
                        if (
                          obj &&
                          typeof obj === 'object' &&
                          'lineFieldId' in obj &&
                          'lines' in obj &&
                          Array.isArray(obj.lines)
                        ) {
                          items.push(<LineTitle key={i}>{obj.lineFieldId}</LineTitle>);
                          for (let j = 0; j < obj.lines.length; j += 1) {
                            items.push(
                              <LineItem key={`${i}-${j}`}>
                                <Label>
                                  <Checkbox
                                    type="checkbox"
                                    name={`productsDel[${obj.lineFieldId}]`}
                                    value={obj.lines[j]}
                                    onChange={this.handleChange}
                                  />
                                  <CheckboxIcon />
                                  {obj.lines[j] || <Placeholder w="100px" h="30px" />}
                                </Label>
                              </LineItem>
                            );
                          }
                        }
                      }
                    }
                    return items;
                  })()}
                </Dd>
              </Dl>
              <ButtonContainer>
                {confirmButton && confirmButton !== '' ? (
                  <Button type="button" value={confirmButton} onClick={this.clickHandleConfirm} />
                ) : null}
              </ButtonContainer>
            </Form>
          </InnerInput>
          {/* --------------------------------------------------
            * confirm
            * -------------------------------------------------- */}
          <InnerConfirm page={page}>
            <Title>{confirmTitle || <Placeholder w="200px" h="30px" />}</Title>
            <Description>{confirmDescription || <Placeholder w="600px" h="50px" />}</Description>
            <Dl>
              {this.state.corporateId ? (
                <React.Fragment>
                  <Dt>{corporateId || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.corporateId || ''}</Dd>
                </React.Fragment>
              ) : null}
              {this.state.salonCode ? (
                <React.Fragment>
                  <Dt>{salonCode || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.salonCode || ''}</Dd>
                </React.Fragment>
              ) : null}
              {this.state.phoneNumber ? (
                <React.Fragment>
                  <Dt>{phoneNumber || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.phoneNumber || ''}</Dd>
                </React.Fragment>
              ) : null}
              {this.state.phoneNumber ? (
                <React.Fragment>
                  <Dt>{salonName || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.salonName || ''}</Dd>
                </React.Fragment>
              ) : null}
              {this.state.email ? (
                <React.Fragment>
                  <Dt>{email || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.email || ''}</Dd>
                </React.Fragment>
              ) : null}
            </Dl>
            <SectionLabel>{changeTitle || <Placeholder w="200px" h="30px" />}</SectionLabel>
            <Dl>
              {this.state.zipCode ? (
                <React.Fragment>
                  <Dt>{zipCode || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.zipCode || ''}</Dd>
                </React.Fragment>
              ) : null}
              {this.state.address ? (
                <React.Fragment>
                  <Dt>{address || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.address || ''}</Dd>
                </React.Fragment>
              ) : null}
              {this.state.tel ? (
                <React.Fragment>
                  <Dt>{tel || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.tel || ''}</Dd>
                </React.Fragment>
              ) : null}
              {this.state.website ? (
                <React.Fragment>
                  <Dt>{website || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.website || ''}</Dd>
                </React.Fragment>
              ) : null}
              {this.state.nearbyStations ? (
                <React.Fragment>
                  <Dt>{nearbyStations || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.nearbyStations || ''}</Dd>
                </React.Fragment>
              ) : null}
              {this.state.parking ? (
                <React.Fragment>
                  <Dt>{parking || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>{this.state.parking || ''}</Dd>
                </React.Fragment>
              ) : null}
            </Dl>
            <Dl className="lines">
              {this.state.productsAdd && Object.keys(this.state.productsAdd).length > 0 ? (
                <React.Fragment>
                  <Dt>{productsAdd || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>
                    {(() => {
                      const items = [];
                      Object.keys(this.state.productsAdd).forEach(lineFieldId => {
                        items.push(<LineTitle key={`title-${items.length}`}>{lineFieldId}</LineTitle>);
                        items.push(
                          <LineItems key={`item-${items.length}`} className="line-items">
                            {this.state.productsAdd[lineFieldId].join(', ')}
                          </LineItems>
                        );
                      });
                      return items;
                    })()}
                  </Dd>
                </React.Fragment>
              ) : null}
              {/* <Hr /> */}
              {this.state.productsDel && Object.keys(this.state.productsDel).length > 0 ? (
                <React.Fragment>
                  <Dt>{productsDel || <Placeholder w="200px" h="30px" />}</Dt>
                  <Dd>
                    {(() => {
                      const items = [];
                      Object.keys(this.state.productsDel).forEach(lineFieldId => {
                        items.push(<LineTitle key={`title-${items.length}`}>{lineFieldId}</LineTitle>);
                        items.push(
                          <LineItems key={`item-${items.length}`} className="line-items">
                            {this.state.productsDel[lineFieldId].join(', ')}
                          </LineItems>
                        );
                      });
                      return items;
                    })()}
                  </Dd>
                </React.Fragment>
              ) : null}
            </Dl>
            <ButtonContainer>
              <Button type="button" value={backButton || ''} onClick={this.clickHandleBack} />
              <Button type="button" value={submitButton || ''} onClick={this.clickHandleSubmit} />
            </ButtonContainer>
          </InnerConfirm>
          {/* --------------------------------------------------
            * thanks
            * -------------------------------------------------- */}
          <InnerThanks page={page}>
            <Title>{thanksTitle || <Placeholder w="200px" h="30px" />}</Title>
            <Description>{thanksDescription || <Placeholder w="600px" h="50px" />}</Description>
            <ButtonContainer>
              <ButtonLink href="/">{completeButtom || ''}</ButtonLink>
            </ButtonContainer>
          </InnerThanks>
          {/* --------------------------------------------------
            * error
            * -------------------------------------------------- */}
          <InnerError page={page}>
            <Title>{errorTitle || <Placeholder w="200px" h="30px" />}</Title>
            <Description>{errorDescription || <Placeholder w="600px" h="50px" />}</Description>
            <ButtonContainer>
              <ButtonLink href="/">{completeButtom || ''}</ButtonLink>
            </ButtonContainer>
          </InnerError>
        </Section>
        {!(locale && title) ? (
          <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_P ? '0 0 20px 40px' : '0 0 20px 20px'} />
        ) : (
          <BreadCrumbMenu
            currentPath={`https://www.shiseido-professional.com/${locale}/salon-info-update`}
            items={[
              {
                name: 'TOP',
                path: `/${locale}/`,
              },
              {
                name: title.toUpperCase(),
                path: null,
              },
            ]}
          />
        )}
      </React.Fragment>
    );
  }
}

SalonInfoUpdatePage.defaultProps = {
  copy: {},
};

SalonInfoUpdatePage.propTypes = {
  copy: PropTypes.shape(),
};

const mapState = state => ({
  copy: state.siteOptions.siteCopySalonInfoUpdatePage,
});

export default connect(mapState)(SalonInfoUpdatePage);



// WEBPACK FOOTER //
// ./src/pages/SalonInfoUpdatePage/SalonInfoUpdatePage.js